import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

 private baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) {}



  fetchUserProfile(userId: string): Observable<any> {
    return this.http.post(`${this.baseUrl}/fetch_user_profile`, { user_id: userId });
  }

   fetchCategories(): Observable<any> {
    return this.http.get(`${this.baseUrl}/fetchCategories`, );
  }
}
